import { createSlice } from "@reduxjs/toolkit";

import CreditMemoModel from "models/CreditMemoModel";
import { initialResultsDtoModel, ResultsDtoModel } from 'models/ResultsDtoModel';

import { getCreditMemos } from "services/credit.service";

import { RootState } from "store/store";


interface CreditMemoState {
    creditMemosDto: ResultsDtoModel<CreditMemoModel>;
    loading: boolean;
    error?: string | null;
}

const initialState: CreditMemoState = {
    creditMemosDto: initialResultsDtoModel,
    loading: false,
    error: null
}

const demoCredit: CreditMemoModel[] = [
    {
        "creditMemoNumber": "BCDCM002567",
        "returnId": 62231821,
        "creditIssuedOn": new Date(),
        "itemNumbers": "ABC-123-24TB",
        "rmaNumber": "RMA00371655",
        "total": 2088.38,
        "transactionId": 62382221,
        "purchaseOrder": "500505055662",
        "fileId": 2,
        "transactionDate": new Date(),
        "status": "Fully Applied"
    },
    {
        "creditMemoNumber": "BCDCM002563",
        "returnId": 61970521,
        "creditIssuedOn": new Date(),
        "itemNumbers": "BCD-312-16TB",
        "rmaNumber": "RMA00370653",
        "total": 1931.58,
        "transactionId": 62127021,
        "purchaseOrder": "500503244233",
        "fileId": 1,
        "transactionDate": new Date(),
        "status": "Open"
    },
    {
        "creditMemoNumber": "BCDCM002562",
        "returnId": 61379221,
        "creditIssuedOn": new Date(),
        "itemNumbers": "BCD-1G-RJ45-PCI",
        "rmaNumber": "RMA00387691",
        "total": 27.01,
        "transactionId": 62126921,
        "purchaseOrder": "500493425131",
        "fileId": 3,
        "transactionDate": new Date(),
        "status": "Open"
    },

]

export const creditMemosSlice = createSlice({
    name: "creditMemos",
    initialState,
    reducers: {
        clearCreditMemos: (state) => {
            state.creditMemosDto = initialResultsDtoModel;
        },
        setDemoCredits: (state) => {
            state.creditMemosDto.items = demoCredit
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCreditMemos.fulfilled, (state, action) => {
                state.creditMemosDto = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getCreditMemos.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getCreditMemos.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'Failed to load credit memos';
            })
    }
});

export const selectCreditMemosDto = (state: RootState) => state.creditMemos.creditMemosDto;
export const creditMemosReducer = creditMemosSlice.reducer;
export const { clearCreditMemos, setDemoCredits } = creditMemosSlice.actions;